import { faArrowRightLong, faCheck, faPen, faSpinner, faSquareCheck, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { Component } from "react";
import MultiSelectDropdown from "../../components/dropdown/MultiSelectDropdown.js";
import { isValidForm } from "../../utils/validation/CommonValidator.js";
import InventoryServices from "../../services/axioServices/apiServices/InventoryServices.js";
import CommonServices from "../../services/axioServices/apiServices/CommonServices.js";
import SwalServices from "../../services/swalServices/SwalServices.js";
import ValidationText from "../../utils/validation/ValidationText.js";
import { CommonSuccessMessages, CommonValidationMessages } from "../../utils/Messages.js";
import ProductionServices from "../../services/axioServices/apiServices/ProductionServices.js";
import moment from "moment";
import Breadcrumb from "../component/Breadcumb.js";

class BatchClearingEntry extends Component {
  constructor(props) {
    super(props);
    this.inventoryServices = new InventoryServices();
    this.productionServices = new ProductionServices();
    this.commonServices = new CommonServices();
    this.SwalServices = new SwalServices();
    this.state = {
      isGridView: true,
      tableStatus1: "",
      tableStatus2: "",
      isLoading: false,
      isEditing: false,
      companyItemList: [],
      batchClearedList: [],
      productionRequisitionList: [],
      productDropdownList: [],
      batchClearingEntryList: [],
      filterDetails: {
        partyName: "",
        productName: "",
        filterBy: "",
        productionStageId: [4],
        batchType: "Pending Batches",
      },
      filterByList: [
        { filterBy: "Slip No.", value: "slipNo" },
        { filterBy: "Batch No", value: "batchNo" },
      ],
      batchTypeList: [
        { batchType: "Pending Batches", value: "PendingBatches" },
        { batchType: "Batch Cleared", value: "BatchCleared" },
      ],
      productionPlanningDetails: {
        productDetialsId: "",
        productionNo: "",
        batchNo: "",
        batchSize: "",
        stdBatchSize: "",
        productId: "",
        mfgDate: "",
        expDate: "",
        size: "",
        colour: "",
        productionStageStatusId: 0,
        packQty: 0,
        packingRequisitionReqDate: "",
        despDate: "",
      },
      batchClearDetails: {
        batchClearingId: "",
        packingItemId: "",
        packing: "",
        unitQty: "",
        quantity: "",
        retainSample: "",
        testQty: "",
        mrp: "",
        pending: "",
        netQuantity: "",
        clearBatch: false,
      },
      validationRules: {
        packingItemId: [
          {
            type: "require",
            message: CommonValidationMessages.SelectRequired.replace(
              "{0}",
              "product name"
            ),
          },
        ],
        quantity: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "quantity"
            ),
          },
        ],
        // retainSample: [
        //   {
        //     type: "require",
        //     message: CommonValidationMessages.FieldRequired.replace(
        //       "{0}",
        //       "retain sample"
        //     ),
        //   },
        // ],
        // testQty: [
        //   {
        //     type: "require",
        //     message: CommonValidationMessages.FieldRequired.replace(
        //       "{0}",
        //       "test quantity"
        //     ),
        //   },
        // ],
        mrp: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "MRP"
            ),
          },
        ],
      },
      validState: {
        isValid: true,
        error: {},
      },
      validationRulesForProductionEntry: {
        despDate: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "dsp date"
            ),
          },
        ],
      },
      validStateForProductionEntry: {
        isValid: true,
        error: {},
      },
    };
  }

  componentDidMount() {
    this.getAllProductionPlanningEntry();
  }

  getAllProductionPlanningEntry = () => {
    this.setState({ tableStatus1: "Loading..." })
    let request = this.state.filterDetails;
    this.productionServices
      .getAllProductionPlanningEntry(request)
      .then((response) => {
        if (response.statusCode === 200 && response.responseData != null) {
          let res = response.responseData;
          if (response.responseData.length === 0) {
            this.setState({ tableStatus1: "No Record Found" })
          } else {
            this.setState({ tableStatus1: "" })
          }
          this.setState({ productionRequisitionList: res }, () => {
            this.getAllProductDropdown();
          });
        } else {
          this.getAllProductDropdown();
          this.SwalServices.Error(
            response.Message
          );
          this.setState({ tableStatus1: "" })
        }
      });
  };

  getAllBatchClearedRecords = () => {
    this.setState({ tableStatus2: "Loading..." })
    let request = this.state.filterDetails;
    this.productionServices.getAllBatchClearedRecords(request).then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        let res = response.responseData;
        if (response.responseData.length === 0) {
          this.setState({ tableStatus2: "No Record Found" })
        } else {
          this.setState({ tableStatus2: "" })
        }
        this.setState({ batchClearedList: res });
      } else {
        this.SwalServices.Error(
          response.Message
        );
        this.setState({ tableStatus2: "" })
      }
    });
  };

  getAllProductDropdown = () => {
    this.commonServices.getAllProductDropdown().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        let res = response.responseData;
        let dropdownItems = res.map((item) => ({
          label: item.productName,
          value: item._id,
        }));
        this.setState({ productDropdownList: dropdownItems }, () => {
          this.getAllItem();
        });
      } else {
        this.getAllItem();
        this.SwalServices.Error(
          response.Message
        );
      }
    });
  };

  getAllItem = () => {
    this.commonServices.getAllItem().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        let res = response.responseData;
        let dropdownItems = res.map((item) => ({
          label: item.ItemName,
          value: item._id,
          packing: item.Packing,
          unitQty: item.UnitQuantity,
        }));

        this.setState({ companyItemList: dropdownItems });
      } else {
        this.SwalServices.Error(
          response.Message
        );
      }
    });
  };

  isValidAllFields = () => {
    const newValidState = isValidForm(
      this.state.batchClearDetails,
      this.state.validationRules,
      this.state.validState
    );
    this.setState({ validState: newValidState });
    return newValidState.isValid;
  };

  isValidAllFieldsForProduction = () => {
    const newValidState = isValidForm(
      this.state.productionPlanningDetails,
      this.state.validationRulesForProductionEntry,
      this.state.validStateForProductionEntry
    );
    this.setState({ validStateForProductionEntry: newValidState });
    return newValidState.isValid;
  };

  addEditProductionPlanningEntry = () => {
    let validStateForProductionEntry = this.isValidAllFieldsForProduction();
    if (validStateForProductionEntry) {
      this.SwalServices.Confirm(
        "",
        ``,
        CommonSuccessMessages.Yes_Text,
        CommonSuccessMessages.No_Text,
        `Are you sure you want to proceed ?`
      ).then((response) => {
        if (response === true) {
          let request = this.state.productionPlanningDetails;
          if (request.productDetialsId === "") {
            delete request.productDetialsId;
          }
          if (this.state.batchClearDetails.clearBatch === true) {
            request.productionStageId = 5;
          } else {
            request.productionStageId = 4;
          }

          this.productionServices
            .addEditProductionPlanningEntry(request)
            .then((response) => {
              if (response.statusCode === 200 && response.responseData !== null) {
                this.SwalServices.Success('Batch Cleared Successfully')
                this.setState({ isGridView: true })
                this.getAllProductionPlanningEntry();
              } else {
                this.getAllProductionPlanningEntry();
                this.setState({ isGridView: true })
                this.SwalServices.Error(response.Message);
              }
            });
        }
      })
    }

  };

  addEditBatchClearingEntry = () => {
    let isValidAllFields = this.isValidAllFields();
    if (isValidAllFields) {
      this.setState({ isLoading: true }, () => {
        let request = this.state.batchClearDetails;
        if (request.batchClearingId === "") {
          delete request.batchClearingId;
        }
        request.productDetialsId =
          this.state.productionPlanningDetails.productDetialsId;
        request.batchNo = this.state.productionPlanningDetails.batchNo
        request.productionNo = this.state.productionPlanningDetails.productionNo
        request.expDate = this.state.productionPlanningDetails.expDate
        request.mfgDate = this.state.productionPlanningDetails.mfgDate
        this.productionServices
          .addEditBatchClearingEntry(request)
          .then((response) => {
            if (response.statusCode === 200 && response.responseData !== null) {
              this.resetBatchForm()
              this.getProductionPlanningEntryById(this.state.productionPlanningDetails.productDetialsId)
              this.SwalServices.Success(response.Message);
              this.setState({ isLoading: false })
            } else {
              this.SwalServices.Error(
                response.Message
              );
              this.setState({ isLoading: false });
            }
          });
      })
    }
  };

  setFilterParameters = (selected, drpIdentity) => {
    let details = this.state.batchClearDetails;
    details[drpIdentity] = selected.value;
    details.packing = selected.packing;
    details.unitQty = selected.unitQty;
    this.setState({ batchClearDetails: details }, () => {
      if (drpIdentity === 'packingItemId') {
        this.calculatePendingAndNetQty()
      }
    });
  };

  handleChange = (event, name, section) => {
    let value = event.target.value;

    if (section === "filterDetails") {
      let details = this.state.filterDetails;
      details[name] = value.toUpperCase();
      this.setState({ filterDetails: details }, () => {
        if (this.state.filterDetails.batchType === 'Pending Batches') {
          this.getAllProductionPlanningEntry();
        } else {
          this.getAllBatchClearedRecords()
        }
      });
    } else if (section === "batchClearDetails") {
      let details = this.state.batchClearDetails;
      details[name] = value.toUpperCase();
      this.setState({ batchClearDetails: details }, () => {
        if (name === "retainSample" || name === "quantity" || name === 'testQty') {
          this.getBatchClearingEntryByProductId(this.state.productionPlanningDetails.productDetialsId)
        }
      });
    } else {
      let details = this.state.productionPlanningDetails;
      details[name] = value;
      this.setState({ productionPlanningDetails: details });
    }
  };

  calculatePendingAndNetQty = () => {
    let details = this.state.batchClearDetails;
    if (
      this.state.batchClearDetails.packingItemId !== "" &&
      (details.netQuantity !== "" ||
        details.netQuantity !== 0 ||
        details.netQuantity !== null)
    ) {
      let batchSize = Number(this.state.productionPlanningDetails.batchSize);
      let quantity = details.quantity ? Number(details.quantity) : 0;
      let retainSample = details.retainSample ? Number(details.retainSample) : 0;
      let testQty = details.testQty ? Number(details.testQty) : 0;
      let unitQty = details.unitQty ? Number(details.unitQty) : 1;

      if (this.state.batchClearingEntryList.length > 0 && !this.state.isEditing) {
        details.pending = details.pending - Math.round((quantity + retainSample + testQty) * unitQty)
      } else {
        details.pending = Math.round(batchSize - ((quantity + retainSample + testQty) * unitQty))
      }

      if (Number(details.netQuantity) > 0 && this.state.batchClearingEntryList.length > 0 && !this.state.isEditing) {
        details.netQuantity = details.netQuantity + ((quantity + retainSample + testQty) * unitQty);
      } else {
        details.netQuantity = ((quantity + retainSample + testQty) * unitQty);
      }
      this.setState({ batchClearDetails: details });
    }
  }

  handleCheckChange = (event, name) => {
    let value = event.target.checked;
    let details = this.state.batchClearDetails;
    details[name] = value;
    this.setState({ batchClearDetails: details });
  };

  handleDropDownChange = (event, name) => {
    const select = event.target.value;
    let details = this.state.filterDetails;
    details[name] = select;
    this.setState({ filterDetails: details }, () => {
      if (this.state.filterDetails.batchType === "Pending Batches") {
        this.getAllProductionPlanningEntry();
      } else {
        // let details = this.state.filterDetails;
        // details.partyName = "";
        // details.productName = "";
        // details.filterBy = "";
        this.setState({ productionRequisitionList: [] }, () => {
          this.getAllBatchClearedRecords();
        });
      }
    });
  };

  closeGridView = () => {
    this.setState({ isGridView: false });
  };
  openGridView = () => {
    this.resetBatchForm();
    this.resetForm();
    this.setState({ isGridView: true });
  };
  resetForm = () => {
    let validState = this.state.validState;
    validState.isValid = true;
    validState.error = {};
    let filterDetails = this.state.filterDetails;
    filterDetails.partyName = "";
    filterDetails.productName = "";
    filterDetails.filterBy = "";
    // filterDetails.productionStageId = [4];
    // filterDetails.batchType = "Pending Batches";
    let details = this.state.productionPlanningDetails;
    details.productDetialsId = "";
    details.productionNo = "";
    details.despDate = "";
    details.mfgDate = "";
    details.expDate = "";
    details.batchNo = "";
    details.batchSize = "";
    this.setState({ productionPlanningDate: details, validState: validState, filterDetails: filterDetails, tableStatus: "" }, () => {
      this.getAllProductionPlanningEntry()
    });
  };

  resetBatchForm = () => {
    let validState = this.state.validState;
    validState.isValid = true;
    validState.error = {};
    let details = this.state.batchClearDetails;
    details.batchClearingId = "";
    details.packingItemId = "";
    details.quantity = "";
    details.retainSample = "";
    details.testQty = "";
    // details.mrp = "";
    // details.pending = "";
    // details.netQuantity = "";
    details.clearBatch = false;
    details.packing = "";
    this.setState({ batchClearDetails: details, isEditing: false, validState: validState });
  };

  getProductionPlanningEntryById = (id, itemId) => {
    this.productionServices
      .getProductionPlanningEntryById(id)
      .then((response) => {
        if (response.statusCode === 200 && response.responseData != null) {
          let details = this.state.productionPlanningDetails;
          let res = response.responseData;
          details.productionNo = res.productionNo;
          details.batchNo = res.batchNo;
          details.batchSize = res.batchSize;
          details.stdBatchSize = res.stdBatchSize ? res.stdBatchSize : "";
          details.productId = res.productId ? res.productId._id : "";
          details.size = res.productId ? res.productId.sizeName : "";
          details.colour = res.productId ? res.productId.color : "";
          details.productDetialsId = res._id ? res._id : "";
          details.mfgDate = res.mfgDate
            ? moment(res.mfgDate).format("yyyy-MM-DD")
            : "";
          details.expDate = res.expDate
            ? moment(res.expDate).format("yyyy-MM-DD")
            : "";

          details.packingRequisitionReqDate = res.packingRequisitionReqDate
            ? moment(res.packingRequisitionReqDate).format("yyyy-MM-DD")
            : "";
          details.stdBatchSize = res.stdBatchSize ? res.stdBatchSize : "";
          details.productionStageStatusId = res.productionStageStatusId;
          details.packingItemId = res.packingItemId ? res.packingItemId : "";
          details.packQty = res.packQty;
          details.despDate = res.despDate
            ? moment(res.despDate).format("yyyy-MM-DD")
            : "";


          let batchDetails = this.state.batchClearDetails
          batchDetails.mrp = res.mrp ? res.mrp : ""
          batchDetails.testQty = res.sampleQty ? res.sampleQty : ""
          // batchDetails.packingItemId = res.packingItemId ? res.packingItemId : ""
          // batchDetails.packing = res.packing ? res.packing : ""
          this.setState({ productionPlanningDetails: details, batchDetails: batchDetails }, () => {
            if (this.state.productionPlanningDetails.productDetialsId !== "") {
              this.getBatchClearingEntryByProductId(
                this.state.productionPlanningDetails.productDetialsId,
                itemId,
                true
              );
            }
          });
        } else {
          this.SwalServices.Error(
            response.Message
          );
        }
      });
  };

  removeProductionPlanningEntryFromBatchCLearingEntryById = (id) => {
    this.SwalServices.Confirm(
      "",
      ``,
      CommonSuccessMessages.Yes_Text,
      CommonSuccessMessages.No_Text,
      `Are you sure you want to delete this item?`
    ).then((response) => {
      if (response === true) {
        this.productionServices.removeProductionPlanningEntryFromBatchCLearingEntryById(id).then((response) => {
          if (response.statusCode === 200 && response.responseData != null) {
            this.getAllProductionPlanningEntry()
            this.SwalServices.Success(response.Message)
          } else {
            this.SwalServices.Error(response.Message);
          }
        });
      }
    })
  }

  getBatchClearingEntryByProductId = (id, ItemId, forLab) => {
    this.productionServices
      .getBatchClearingEntryByProductId(id)
      .then((response) => {
        if (response.statusCode === 200 && response.responseData != null) {
          let res = response.responseData;
          if (res.length > 0) {
            let batchSize = this.state.productionPlanningDetails.batchSize
            let unitQty = Number(this.state.companyItemList.find((x) => x.value === res[0].packingItemId).unitQty).toFixed(2)
            const totalQty = res.reduce((sum, item) => sum + item.quantity, 0);
            const totalRetainSample = res.reduce((sum, item) => sum + item.retainSample, 0);
            const totalTestQty = res.reduce((sum, item) => sum + item.testQty, 0);

            let batchClearDetails = this.state.batchClearDetails;

            if (forLab) {
              const hasTestQty = res.some(item => Number(item.testQty) > 0);
              if (hasTestQty) {
                batchClearDetails.testQty = "";
              }
            }

            batchClearDetails.pending = Math.round(batchSize - ((totalQty + totalRetainSample + totalTestQty) * unitQty))
            batchClearDetails.netQuantity = ((totalQty + totalRetainSample + totalTestQty) * unitQty);

            this.setState({ batchClearDetails: batchClearDetails })
          }
          this.setState({ batchClearingEntryList: res, isGridView: false }, () => {
            this.calculatePendingAndNetQty()
            if (ItemId) {
              this.adjustBatchClearingEntry(ItemId);
            }
          });
        } else {
          this.SwalServices.Error(
            response.Message
          );
        }
      });
  };

  adjustBatchClearingEntry = (id) => {
    let item = this.state.batchClearingEntryList.find((x) => x._id === id);
    let details = this.state.batchClearDetails;
    details.batchClearingId = item._id;
    details.packingItemId = item.packingItemId;
    details.quantity = item.quantity;
    details.retainSample = item.retainSample;
    details.testQty = item.testQty;
    details.mrp = item.mrp;
    // details.pending = Math.round(
    //   this.state.productionPlanningDetails.batchSize -
    //   this.state.batchClearingEntryList.reduce(
    //     (total, item) => total + (item.netQuantity > 0 ? Number(item.netQuantity) : 0),
    //     0
    //   )
    // );
    // details.netQuantity = item.netQuantity;
    details.clearBatch = item.clearBatch;
    details.packing = this.state.companyItemList.find(
      (x) => x.value === item.packingItemId
    ).packing;
    details.unitQty = this.state.companyItemList.find(
      (x) => x.value === item.packingItemId
    ).unitQty;
    this.setState({ batchClearDetails: details, isEditing: true }, () => this.calculatePendingAndNetQty());
  };

  deleteBatchCLearingEntryById = (id) => {
    let request = {
      batchClearingId: id,
      batchNo: this.state.productionPlanningDetails.batchNo,
    }
    this.productionServices.deleteBatchCLearingEntryById(request).then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        this.SwalServices.Success(response.Message);
        this.getBatchClearingEntryByProductId(this.state.productionPlanningDetails.productDetialsId);
      } else {
        this.SwalServices.Error(response.Message);
      }
    });
  }

  clearBatch = () => {
    let details = this.state.batchClearDetails;
    details.clearBatch = true;
    if (this.state.batchClearingEntryList.length > 0) {
      this.setState({ batchClearDetails: details }, () => {
        this.addEditProductionPlanningEntry()
      });
    } else {
      this.SwalServices.Alert('Please enter at least one batch.')
    }
  }

  unclearBatch = () => {
    let details = this.state.batchClearDetails;
    details.clearBatch = false;
    if (this.state.batchClearingEntryList.length > 0) {
      this.setState({ batchClearDetails: details }, () => {
        this.addEditProductionPlanningEntry()
      });
    } else {
      this.SwalServices.Alert('Please enter at least one batch.')
    }
  }

  render() {
    const activePage = "Batch Clearing";
    return (
      <div className="batchClearing-page">
        {this.state.isGridView === true ? (
          <>
            {/* <Breadcrumb page={activePage} /> */}
            <div className='flex gap-[8px] items-center mb-[8px]'>
              {/* <div className="h-[20px] w-[20px]"><FontAwesomeIcon icon={faSquareCheck} style={{ height: "100%", width: "100%", }} /></div> */}
              {/* <img
                src="box.png"
                alt="A placeholder image"
              /> */}
              <p className='text-lg font-bold text-gray-700'>Batch Clearing</p>
            </div>
            <div className="item-search">
              <div className="item-grp grid grid-cols-3 gap-[10px]">
                {/* <div className="search-grp">
                  <label>Party Name:</label>
                  <input
                    type="text"
                    id="partyName"
                    name="partyName"
                    autoComplete="off"
                    className="inputFocus w-full"
                    value={this.state.filterDetails.partyName}
                    onChange={(event) =>
                      this.handleChange(event, "partyName", "filterDetails")
                    }
                  />
                </div> */}
                <div className="search-grp">
                  <label>Product Name:</label>
                  <input
                    type="text"
                    id="productName"
                    name="productName"
                    autoComplete="off"
                    className="inputFocus w-full"
                    value={this.state.filterDetails.productName}
                    onChange={(event) =>
                      this.handleChange(event, "productName", "filterDetails")
                    }
                  />
                </div>
                <div className="searchInner-grp grid grid-cols-2 gap-2.5">
                  <div className="search-grp">
                    <label>Filter By:</label>
                    <select
                      name="filterBy"
                      className="w-full"
                      value={this.state.filterDetails.filterBy}
                      onChange={(event) =>
                        this.handleDropDownChange(
                          event,
                          "filterBy",
                          "filterDetails"
                        )
                      }
                    >
                      <option>Select</option>
                      {this.state.filterByList.map((x, key) => (
                        <option key={key} value={x.value}>
                          {x.filterBy}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="search-grp">
                    <label>Batch Type:</label>
                    <select
                      name="batchType"
                      className="w-full"
                      value={this.state.filterDetails.batchType}
                      onChange={(event) =>
                        this.handleDropDownChange(
                          event,
                          "batchType",
                          "filterDetails"
                        )
                      }
                    >
                      {this.state.batchTypeList.map((x, key) => (
                        <option key={key} value={x.batchType}>
                          {x.batchType}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div className="itemList-table mt-3.5">
              <div className="table-container" style={{ height: 'calc(100vh - 160px)' }}>
                {this.state.filterDetails.batchType === "Pending Batches" ? (
                  <table className="itemList">
                    <thead>
                      <tr>
                        <td style={{ width: "9%" }}>Prod.No</td>
                        <td style={{ width: "10%" }}>Prod.Date</td>
                        {/* <td style={{ width: "25%" }}>Party Name</td> */}
                        <td style={{ width: "30%" }}>Product Name</td>
                        <td style={{ width: "12%" }}>Batch No</td>
                        <td style={{ width: "12%" }}>Batch Size</td>
                        <td style={{ width: "10%", textAlign: "center" }}>
                          Action
                        </td>
                      </tr>
                    </thead>
                    {this.state.productionRequisitionList &&
                      this.state.productionRequisitionList.length > 0 ? (
                      this.state.productionRequisitionList.map((item, key) => (
                        <tbody key={key}>
                          <tr>
                            <td>{item.productionNo}</td>
                            <td>
                              {item.productionPlanningDate
                                ? moment(item.productionPlanningDate).format(
                                  "DD MMM yyyy"
                                )
                                : ""}
                            </td>
                            {/* <td>
                              {item.partyId?.partyName
                                ? item.partyId.partyName
                                : ""}
                            </td> */}
                            <td>
                              {item.productId?.productName
                                ? item.productId?.productName
                                : ""}
                            </td>
                            <td>{item.batchNo}</td>
                            <td>{item.batchSize}</td>
                            <td style={{ textAlign: "center" }}>
                              {/* <button
                                className="add-btn gap-1.25 !w-fit !h-fit !py-1.25 !px-[8px] leading-normal"
                                onClick={() =>
                                  this.getProductionPlanningEntryById(item._id)
                                }
                              >
                                Proceed
                                <FontAwesomeIcon icon={faArrowRightLong} />
                              </button> */}
                              <button
                                className="search-btn"
                                onClick={() =>
                                  this.getProductionPlanningEntryById(item._id)
                                }
                                title="Edit"
                              >
                                <FontAwesomeIcon icon={faPen} />
                              </button>
                              <button
                                className="cancel-btn"
                                onClick={() => this.removeProductionPlanningEntryFromBatchCLearingEntryById(item._id)}
                              >
                                <FontAwesomeIcon icon={faTrash} />
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      ))
                    ) : this.state.productionRequisitionList
                      && this.state.productionRequisitionList.length === 0
                      && this.state.tableStatus1 !== "" ? (
                      <tr>
                        <td colSpan={7} style={{ textAlign: "center", fontSize: "16px" }}>
                          {this.state.tableStatus1}
                        </td>
                      </tr>
                    ) : this.state.productionRequisitionList
                      && this.state.productionRequisitionList.length === 0
                      && this.state.tableStatus1 === "" ? null : ""}
                  </table>
                ) : (
                  <table className="itemList">
                    <thead>
                      <tr>
                        <td style={{ width: "12%" }}>Prod.No</td>
                        <td style={{ width: "12%" }}>Desp.Date</td>
                        <td style={{ width: "12%" }}>Batch No</td>
                        <td style={{ width: "30%" }}>Product Name</td>
                        <td style={{ width: "12%" }}>Quantity</td>
                        <td style={{ width: "12%" }}>MRP</td>
                        <td style={{ width: "10%", textAlign: "center" }}>
                          Action
                        </td>
                      </tr>
                    </thead>
                    {this.state.batchClearedList &&
                      this.state.batchClearedList.length > 0 ? (
                      this.state.batchClearedList.map((item, key) => (
                        <tbody key={key}>
                          <tr>
                            <td>{item.productionNo}</td>
                            <td>
                              {item?.despDate ? moment(item?.despDate).format("DD MMM yyyy") : ""}
                            </td>
                            <td>{item.batchNo}</td>
                            <td>{item.productName ? item.productName : ""} </td>
                            <td>{item.totalQuantity}</td>
                            <td>{item.mrp}</td>
                            <td style={{ textAlign: "center" }}>
                              <button
                                className="search-btn"
                                onClick={() =>
                                  this.getProductionPlanningEntryById(
                                    item.productDetialsId,
                                    item._id
                                  )
                                }
                                title="Edit"
                              >
                                <FontAwesomeIcon icon={faPen} />
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      ))
                    ) : this.state.batchClearedList
                      && this.state.batchClearedList.length === 0
                      && this.state.tableStatus2 !== "" ? (
                      <tr>
                        <td colSpan={7} style={{ textAlign: "center", fontSize: "16px" }}>
                          {this.state.tableStatus2}
                        </td>
                      </tr>
                    ) : this.state.batchClearedList
                      && this.state.batchClearedList.length === 0
                      && this.state.tableStatus2 === "" ? null : ""}
                  </table>
                )}
              </div>
            </div>
          </>
        ) : null}

        {this.state.isGridView === false ? (
          <div className="item-listing">
            <div className="item-form">
              <div className="form-table">
                <div className="item-grp grid grid-cols-4 gap-2.5 mb-3">
                  <div className="input-grp col-span-2">
                    <label>Product Name</label>
                    <MultiSelectDropdown
                      drpIdentity="productId"
                      options={this.state.productDropdownList}
                      closeMenuOnSelect={true}
                      hideSelectedOptions={false}
                      onChange={(selected) =>
                        this.setFilterParameters(selected, "productId")
                      }
                      allowSelectAll={false}
                      value={this.state.productDropdownList.filter(
                        (party) =>
                          party.value ===
                          this.state.productionPlanningDetails.productId
                      )}
                      isDisabled={true}
                    />
                    {/* <ValidationText
                      error={this.state.validState.error.productId}
                    /> */}
                  </div>
                  <div className="input-grp">
                    <label>Prod. No</label>
                    <input
                      type="text"
                      disabled
                      id="productionNo"
                      name="productionNo"
                      autoComplete="off"
                      value={this.state.productionPlanningDetails.productionNo}
                      onChange={(event) =>
                        this.handleChange(
                          event,
                          "productionNo",
                          "batchClearDetails"
                        )
                      }
                    />
                    {/* <ValidationText
                      error={this.state.validState.error.productionNo}
                    /> */}
                  </div>
                  <div className="input-grp">
                    <label>Dsp. Date</label>
                    <input
                      // className={` inputFocus ${this.state.validState?.error?.despDate ? "errorInput" : ""}`}
                      type="date"
                      id="despDate"
                      name="despDate"
                      autoComplete="off"
                      value={this.state.productionPlanningDetails.despDate}
                      onChange={(event) => this.handleChange(event, "despDate")}
                    />
                    {/* <ValidationText
                      error={
                        this.state.validStateForProductionEntry.error.despDate
                      }
                    /> */}
                  </div>
                </div>
                <div className="item-grp grid grid-cols-4 gap-2.5">
                  <div className="input-grp">
                    <label>Mfg. Date</label>
                    <input
                      className="inputFocus"
                      type="date"
                      disabled
                      id="mfgDate"
                      name="mfgDate"
                      autoComplete="off"
                      value={this.state.productionPlanningDetails.mfgDate}
                      onChange={(event) =>
                        this.handleChange(event, "mfgDate", "batchClearDetails")
                      }
                    />
                    {/* <ValidationText
                      error={this.state.validState.error.mfgDate}
                    /> */}
                  </div>
                  <div className="input-grp">
                    <label>Exp. Date</label>
                    <input
                      className="inputFocus"
                      type="date"
                      disabled
                      id="expDate"
                      name="expDate"
                      autoComplete="off"
                      value={this.state.productionPlanningDetails.expDate}
                      onChange={(event) =>
                        this.handleChange(event, "expDate", "batchClearDetails")
                      }
                    />
                    {/* <ValidationText
                      error={this.state.validState.error.expDate}
                    /> */}
                  </div>
                  <div className="input-grp">
                    <label>Batch No</label>
                    <input
                      className="inputFocus"
                      disabled
                      type="text"
                      id="batchNo"
                      name="batchNo"
                      autoComplete="off"
                      value={this.state.productionPlanningDetails.batchNo}
                      onChange={(event) =>
                        this.handleChange(event, "batchNo", "batchClearDetails")
                      }
                    />
                    {/* <ValidationText
                      error={this.state.validState.error.batchNo}
                    /> */}
                  </div>
                  <div className="input-grp">
                    <label>Batch Size</label>
                    <input
                      className="inputFocus"
                      disabled
                      type="text"
                      id="batchSize"
                      name="batchSize"
                      autoComplete="off"
                      value={this.state.productionPlanningDetails.batchSize}
                      onChange={(event) =>
                        this.handleChange(
                          event,
                          "batchSize",
                          "batchClearDetails"
                        )
                      }
                    />
                    {/* <ValidationText
                      error={this.state.validState.error.batchSize}
                    /> */}
                  </div>
                </div>
              </div>
              <hr className="mt-4 mb-4" />
              <div className="form-table">
                <div className="item-grp grid grid-cols-4 gap-2.5 mb-3">
                  <div className="itemInner-grp col-span-2 flex gap-2.5">
                    <div className="input-grp w-[80%]">
                      <label>Item Name</label>
                      <MultiSelectDropdown
                        className={`  ${this.state.validState?.error?.packingItemId ? "errorInput" : ""}`}
                        drpIdentity="packingItemId"
                        options={this.state.companyItemList}
                        // isMulti
                        // components={{
                        //   Option
                        // }}
                        closeMenuOnSelect={true}
                        hideSelectedOptions={false}
                        onChange={(selected) =>
                          this.setFilterParameters(selected, "packingItemId")
                        }
                        allowSelectAll={false}
                        value={this.state.companyItemList.filter(
                          (party) =>
                            party.value ===
                            this.state.batchClearDetails.packingItemId
                        )}
                      />
                      {/* <ValidationText
                        error={this.state.validState.error.packingItemId}
                      /> */}
                    </div>
                    <div className="input-grp w-[20%]">
                      <label>Packing</label>
                      <input
                        type="text"
                        autoComplete="off"
                        value={this.state.batchClearDetails.packing || ""}
                        disabled
                      />
                    </div>
                  </div>
                  <div className="input-grp">
                    <div className="input-label">
                      <label>Quantity</label>
                      <input
                        className={` inputFocus ${this.state.validState?.error?.quantity ? "errorInput" : ""}`}
                        type="number"
                        id="quantity"
                        name="quantity"
                        autoComplete="off"
                        value={this.state.batchClearDetails.quantity}
                        disabled={!this.state.batchClearDetails.packingItemId}
                        onChange={(event) =>
                          this.handleChange(
                            event,
                            "quantity",
                            "batchClearDetails"
                          )
                        }
                      />
                      {/* <ValidationText
                        error={this.state.validState.error.quantity}
                      /> */}
                    </div>
                  </div>
                  <div className="input-grp">
                    <label>Retain Sample</label>
                    <input
                      className="inputFocus"
                      type="number"
                      id="retainSample"
                      name="retainSample"
                      autoComplete="off"
                      value={this.state.batchClearDetails.retainSample}
                      disabled={!this.state.batchClearDetails.packingItemId}
                      onChange={(event) =>
                        this.handleChange(
                          event,
                          "retainSample",
                          "batchClearDetails"
                        )
                      }
                    />

                  </div>
                </div>
                <div className="item-grp grid grid-cols-4 gap-2.5 mb-3.5">
                  <div className="input-grp">
                    <label>Lab Test Qty.</label>
                    <input
                      className="inputFocus"
                      type="number"
                      id="testQty"
                      name="testQty"
                      autoComplete="off"
                      value={this.state.batchClearDetails.testQty}
                      onChange={(event) =>
                        this.handleChange(event, "testQty", "batchClearDetails")
                      }
                      disabled={!this.state.batchClearDetails.packingItemId}
                    />

                  </div>
                  <div className="input-grp">
                    <label>M.R.P. Rs.</label>
                    <input
                      className={` inputFocus ${this.state.validState?.error?.mrp ? "errorInput" : ""}`}
                      type="number"
                      id="mrp"
                      name="mrp"
                      autoComplete="off"
                      value={this.state.batchClearDetails.mrp}
                      onChange={(event) =>
                        this.handleChange(event, "mrp", "batchClearDetails")
                      }
                      disabled={!this.state.batchClearDetails.packingItemId}
                    // disabled={true}
                    />
                    {/* <ValidationText error={this.state.validState.error.mrp} /> */}
                  </div>
                  <div className="input-grp">
                    <label>Pending</label>
                    <input
                      type="text"
                      id="pending"
                      name="pending"
                      autoComplete="off"
                      className="inputFocus"
                      disabled
                      value={this.state.batchClearDetails.pending}
                      onChange={(event) =>
                        this.handleChange(event, "pending", "batchClearDetails")
                      }
                    />
                    {/* <ValidationText
                      error={this.state.validState.error.pending}
                    /> */}
                  </div>
                  <div className="input-grp">
                    <label>Net Quantity</label>
                    <input
                      type="number"
                      id="netQuantity"
                      name="netQuantity"
                      autoComplete="off"
                      className="inputFocus"
                      disabled
                      value={this.state.batchClearDetails.netQuantity}
                      onChange={(event) =>
                        this.handleChange(
                          event,
                          "netQuantity",
                          "batchClearDetails"
                        )
                      }
                    />
                    {/* <ValidationText
                      error={this.state.validState.error.netQuantity}
                    /> */}
                  </div>

                </div>
              </div>
              <div className="btn-grp flex gap-2.5 mb-4">
                {/* {this.state.isEditing === true ? (
                  <button
                    className="add-btn"
                    onClick={() => {
                      this.addEditBatchClearingEntry();
                    }}
                  >
                    Save
                  </button>
                ) : (
                  <button
                    className="add-btn"
                    onClick={() => {
                      this.addEditBatchClearingEntry();
                    }}
                  // disabled={this.state.filterDetails.batchType === 'Batch Cleared'}
                  >
                    Add
                  </button>
                )} */}
                {this.state.isEditing === true ? (
                  <button
                    className="add-btn"
                    disabled={this.state.isLoading}
                    onClick={() => this.addEditBatchClearingEntry()}
                  >
                    {this.state.isLoading ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Save"}
                  </button>
                ) : (
                  <button
                    className="add-btn"
                    disabled={this.state.isLoading}
                    onClick={() => this.addEditBatchClearingEntry()}
                  >
                    {this.state.isLoading ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Add"}
                  </button>
                )}
                <button
                  className="cancel-btn"
                  onClick={() => this.resetBatchForm()}
                  disabled={this.state.isLoading}
                // disabled={this.state.filterDetails.batchType === 'Batch Cleared'}
                >
                  Cancel
                </button>
                <button
                  className="back-btn"
                  onClick={() => this.openGridView()}
                  disabled={this.state.isLoading}
                >
                  Back
                </button>

                {this.state.filterDetails.batchType === 'Pending Batches' && this.state.batchClearingEntryList.length > 0 ?
                  <button style={{ border: "1px solid lightgray", borderRadius: "10px", padding: "5px 10px" }} className="hover:bg-[#f0f8ff]"
                    onClick={() => this.clearBatch()}
                    disabled={this.state.isLoading}>
                    Complete Clear Batch
                  </button>
                  : null}

                {/* {this.state.filterDetails.batchType === 'Batch Cleared' ?
                  <button style={{ border: "1px solid lightgray", borderRadius: "10px", padding: "5px 10px" }} className="hover:bg-[#f0f8ff]" onClick={() => this.unclearBatch()}>
                    Unclear Batch
                  </button>
                  : null}*/}

              </div>
            </div>
            <div className="itemList-table">
              <div className="table-container" style={{ height: "calc(100vh - 430px)" }}>
                <table className="itemList">
                  <thead>
                    <tr>
                      <td className="w-1/10">Prod. No</td>
                      <td className="w-1/10">Date</td>
                      <td className="w-1/10">Pack</td>
                      <td className="w-1/10">Quantity</td>
                      <td className="w-1/10">MRP</td>
                      <td className="w-1/10 !text-center">Action</td>
                    </tr>
                  </thead>
                  {this.state.batchClearingEntryList &&
                    this.state.batchClearingEntryList.length > 0 ? (
                    this.state.batchClearingEntryList.map((item, key) => (
                      <tbody key={key}>
                        <tr>
                          <td>{item.productDetialsId.productionNo}</td>
                          <td>
                            {item.productDetialsId.despDate
                              ? moment(item.productDetialsId.despDate).format(
                                "DD MMM yyyy"
                              )
                              : null}
                          </td>
                          <td>{item.packing}</td>
                          <td>{item.quantity}</td>
                          <td>{item.mrp}</td>
                          <td style={{ textAlign: "center" }}>
                            <button
                              className="search-btn"
                              onClick={() =>
                                this.adjustBatchClearingEntry(item._id)
                              }
                              // disabled={this.state.filterDetails.batchType === 'Batch Cleared'}
                              title="Edit"
                            >
                              <FontAwesomeIcon icon={faPen} />
                            </button>
                            <button
                              className="cancel-btn"
                              onClick={() => this.deleteBatchCLearingEntryById(item._id)}
                            >
                              <FontAwesomeIcon icon={faTrash} />
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    ))
                  ) : (
                    <tbody className="validation-body">
                      <tr>
                        <td
                          colSpan={6}
                          style={{ textAlign: "center", fontSize: "16px" }}
                        >
                          No Records Found
                        </td>
                      </tr>
                    </tbody>
                  )}
                </table>

              </div>
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}

export default BatchClearingEntry;
